import { tmsTrackView, tmsTrackEvent } from './tealiumHelperUtils';

export function landingPageEsgTmsTrackView() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire',
		pageSubcategory: 'sustainability preferences questionnaire',
		raw_datalayer: '18431v7'
	};
	tmsTrackView(teamluimObj);
}

export function knowMoreAboutEsgEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire',
		event_category: 'content',
		event_action: 'onsite',
		event_content: 'know more about ESG and sustainability at HSBC',
		pageSubcategory: 'sustainability preferences questionnaire',
		raw_datalayer: '18431v8'
	};
	tmsTrackEvent(teamluimObj);
}

export function backFromEsgStartPageEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire',
		event_category: 'content',
		event_action: 'button',
		event_content: 'back click',
		pageSubcategory: 'sustainability preferences questionnaire',
		raw_datalayer: '18431v9'
	};
	tmsTrackEvent(teamluimObj);
}

export function startTheQuestionnaireEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire',
		event_category: 'content',
		event_action: 'button',
		event_content: 'start the questionnaire click',
		pageSubcategory: 'sustainability preferences questionnaire',
		raw_datalayer: '18431v10'
	};
	tmsTrackEvent(teamluimObj);
}


export function confirmationPageEsgTmsTrackView() {
	const teamluimObj = {
		page_url_category: 'confirmation',
		pageSubcategory: 'confirmation',
		raw_datalayer: '18431v21'
	};
	tmsTrackView(teamluimObj);
}

export function visitEsgAnalysisPageEvent() {
	const teamluimObj = {
		page_url_category: 'confirmation',
		event_category: 'content',
		event_action: 'button',
		event_content: 'button: Visit ESG Analysis page',
		pageSubcategory: 'confirmation',
		raw_datalayer: '18431v22'
	};
	tmsTrackEvent(teamluimObj);
}

export function exploreEsgSIProductEvent() {
	const teamluimObj = {
		page_url_category: 'confirmation',
		event_category: 'content',
		event_action: 'button',
		event_content: 'button: Explore ESG and SI Product',
		pageSubcategory: 'confirmation',
		raw_datalayer: '18431v23'
	};
	tmsTrackEvent(teamluimObj);
}

export function retakeButtonEvent() {
	const teamluimObj = {
		page_url_category: 'confirmation',
		event_category: 'content',
		event_action: 'button',
		event_content: 'click : retake questionnaire',
		pageSubcategory: 'confirmation',
		raw_datalayer: '18431v24'
	};
	tmsTrackEvent(teamluimObj);
}

export function retakeQuestionnaireEsgTmsTrackView() {
	const teamluimObj = {
		page_url_category: 'retake-the-questionnaire',
		pageSubcategory: 'retake the questionnaire',
		raw_datalayer: '18431v25'
	};
	tmsTrackView(teamluimObj);
}

export function cancelRetakeButtonEvent() {
	const teamluimObj = {
		page_url_category: 'retake-the-questionnaire',
		event_category: 'content',
		event_action: 'button',
		event_content: 'button: cancel',
		pageSubcategory: 'retake the questionnaire',
		raw_datalayer: '18431v26'
	};
	tmsTrackEvent(teamluimObj);
}

export function proccedRetakeButtonEvent() {
	const teamluimObj = {
		page_url_category: 'retake-the-questionnaire',
		event_category: 'content',
		event_action: 'button',
		event_content: 'Button: procced',
		pageSubcategory: 'retake the questionnaire',
		raw_datalayer: '18431v27'
	};
	tmsTrackEvent(teamluimObj);
}

export function closedRetakeButtonEvent() {
	const teamluimObj = {
		page_url_category: 'retake-the-questionnaire',
		event_category: 'content',
		event_action: 'onsite',
		event_content: 'close',
		pageSubcategory: 'retake the questionnaire',
		raw_datalayer: '18431v28'
	};
	tmsTrackEvent(teamluimObj);
}

export function questionnarieOneTmsTrackView() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-1',
		pageSubcategory: 'sustainability preferences questionnaire 1',
		raw_datalayer: '18431v11'
	};
	tmsTrackView(teamluimObj);
}

export function questionnarieTwoTmsTrackView() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-1',
		pageSubcategory: 'sustainability preferences questionnaire 1',
		raw_datalayer: '18431v16'
	};
	tmsTrackView(teamluimObj);
}

export function questionnarieThreeTmsTrackView() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-3',
		pageSubcategory: 'sustainability questionnaire 3',
		raw_datalayer: '18431v26'
	};
	tmsTrackView(teamluimObj);
}

//Ques1
export function questionnarieOneRadioOneTmsTrackEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-1',
		pageSubcategory: 'sustainability preferences questionnaire 1',
		event_category: 'content',
		event_action: 'radio',
		event_content: 'radio button: yes I am interested',
		raw_datalayer: '18431v12'
	};

	tmsTrackEvent(teamluimObj);
}

export function questionnarieOneRadioTwoTmsTrackEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-1',
		pageSubcategory: 'sustainability preferences questionnaire 1',
		event_category: 'content',
		event_action: 'radio',
		event_content: 'radio button: no, I am not interested',
		raw_datalayer: '18431v13'
	};

	tmsTrackEvent(teamluimObj);
}

//Ques2
export function questionnarieTwoCheckboxOneTmsTrackEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-2',
		event_category: 'content',
		event_action: 'radio',
		event_content: 'radio button: yes I am interested',
		pageSubcategory: 'sustainability preferences questionnaire 2',
		raw_datalayer: '18431v17'
	};

	tmsTrackEvent(teamluimObj);
}

export function questionnarieTwoCheckboxTwoTmsTrackEvent() {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-2',
		event_category: 'content',
		event_action: 'radio',
		event_content: 'radio button: no, I am not interested',
		pageSubcategory: 'sustainability preferences questionnaire 2',
		raw_datalayer: '18431v18'
	};

	tmsTrackEvent(teamluimObj);
}

export function questionnarieBackBtnTmsTrackEvent(currentQues) {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-' + currentQues,
		event_category: 'content',
		event_action: 'button',
		event_content: 'button:back',
		pageSubcategory: currentQues === 1? 'sustainability preferences questionnaire 1' : 'sustainability preferences questionnaire 2',
		raw_datalayer: currentQues === 1? '18431v15' : '18431v20'
	};

	tmsTrackEvent(teamluimObj);
}

export function questionnarieCtnBtnTmsTrackEvent(currentQues) {
	const teamluimObj = {
		page_url_category: 'sustainability-preferences-questionnaire-' + currentQues,
		event_category: 'content',
		event_action: 'button',
		event_content: 'button:continue',
		pageSubcategory: 'sustainability preferences questionnaire '+ currentQues,
		raw_datalayer: currentQues === 1? '18431v14' : '18431v19'

	};

	tmsTrackEvent(teamluimObj);
}
